import React from 'react';

//Dependencies.
import { Form, FormGroup, Input, Label } from 'reactstrap';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

//Slice
  //Data
  import { allUpcomingChallenges } from '../../../../../slices/challengesSlice';

import "./AddVideoToChallengeForm.styles.css";


const AddVideoToChallengeForm = () => {
   const upcomingChallenges = useSelector(allUpcomingChallenges);
   const params = useParams();
   const currentUpcomingChallenge = upcomingChallenges[params._challengeID];

   return (
      <Form action={`https://formsubmit.co/${process.env.REACT_APP_HOTMAIL}`} method="POST">
         <FormGroup className='p-0 m-0'>
            <Input type="hidden" name="_subject" value={`New video(s) has been added to challenge ID# ${currentUpcomingChallenge._challengeID}!!!`} />
         </FormGroup>
         <FormGroup>
            {/* <Input type="hidden" name="_next" value={`http://localhost:3000/challenges/details/announcement/${params._challengeID}`} /> */}
            <Input type="hidden" name="_next" value= "http://localhost:3000" />
         </FormGroup>
         <FormGroup style={{display: "none"}}>         
            <Label htmlFor='message'>MESSAGE:</Label>
            <Input type='textarea' name='message' placeholder='Add Your Message Here' className='p-1' value={`At least one new video has been added to your challenge (ID# ${params._challengeID}). Please log into your member portal to view. Thank-you.`} readOnly />         
         </FormGroup>
         <div class="d-grid gap-2">
            <button class="btn btn-success" type="submit">DONE ADDING VIDEOS!!!</button>
         </div>
      </Form>
   )
}

export default AddVideoToChallengeForm